export const SubHeader = ( {current} ) => {
  return (
    <>
    <h2>{current}</h2>
    <hr />
    </>
  )
}